export const downloadURL = "https://afga-elmisbackend.support.af/Documents"
// export const downloadURL = "https://api.elmis.af/Documents"
// export const downloadURL = "http://localhost:8000/Documents"
